/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Topic_BillingInputs */

const en_contact_topic_billing = /** @type {(inputs: Contact_Topic_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payments`)
};

const pl_contact_topic_billing = /** @type {(inputs: Contact_Topic_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Płatności`)
};

/**
* | output |
* | --- |
* | "Payments" |
*
* @param {Contact_Topic_BillingInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_topic_billing = /** @type {((inputs?: Contact_Topic_BillingInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Topic_BillingInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_topic_billing(inputs)
	return en_contact_topic_billing(inputs)
});